// extracted by mini-css-extract-plugin
module.exports = {"root":"SliderSection_root__CitTE"};